(function () {
  'use strict';
  if (window.dhPasswordSignupLoaded) return;
  window.dhPasswordSignupLoaded = true;

  function phoneDigits(value) {
    var digits = value.replace(/\D/g, '');
    return digits.length === 11 && digits.charAt(0) === '1' ? digits.slice(1) : digits;
  }

  function normalizeEmail(value) {
    var address = value.trim();
    var separator = address.indexOf('@');
    if (separator < 1 || separator !== address.lastIndexOf('@')) return address;
    var local = address.slice(0, separator);
    var domain = address.slice(separator + 1);
    // URL parsing is only for international domains, never for the local part.
    // Reject URL delimiters rather than silently changing a malformed address.
    if (!/[^\x00-\x7f]/.test(domain) || /[^\x00-\x7f]/.test(local) || /[\s\/\\?#:%\[\]]/.test(domain)) return address;
    try {
      var parsed = new URL('https://' + domain + '/');
      // A URL may reinterpret Unicode numeric labels as an IPv4 shorthand.
      // Decline that input instead of subscribing a different email identity.
      if (/^\d+\.\d+\.\d+\.\d+$/.test(parsed.hostname)) return address;
      if (parsed.hostname && parsed.pathname === '/' && !parsed.username && !parsed.password && !parsed.port) return local + '@' + parsed.hostname;
    } catch (error) { /* Native email validation will reject an unsupported domain. */ }
    return address;
  }

  function formatPhone(value) {
    var digits = phoneDigits(value);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return digits.slice(0, 3) + '-' + digits.slice(3);
    return digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function formatPhoneInput(input) {
    var raw = input.value;
    var digits = raw.replace(/\D/g, '');
    var start = raw.slice(0, input.selectionStart === null ? raw.length : input.selectionStart).replace(/\D/g, '').length;
    var end = raw.slice(0, input.selectionEnd === null ? raw.length : input.selectionEnd).replace(/\D/g, '').length;
    if (digits.length === 11 && digits.charAt(0) === '1') {
      start = Math.max(0, start - 1);
      end = Math.max(0, end - 1);
    }
    var formatted = formatPhone(raw);
    function position(count) {
      if (!count) return 0;
      var found = 0;
      for (var index = 0; index < formatted.length; index += 1) {
        if (/\d/.test(formatted[index]) && ++found === count) return index + 1;
      }
      return formatted.length;
    }
    input.value = formatted;
    input.setSelectionRange(position(start), position(end));
  }

  function bind(form) {
    if (form.dataset.fwSignupBound) return;
    var name = form.elements.namedItem('name');
    var email = form.elements.namedItem('email');
    var phone = form.elements.namedItem('phone');
    var smsConsent = form.elements.namedItem('sms_consent');
    var steps = Array.from(form.querySelectorAll('[data-signup-step]'));
    var status = form.querySelector('.fw-signup__status');
    var stage = 'email';
    var submittedEmail = '';
    var signupAttribution;
    var busy = false;
    var configured = Boolean(form.dataset.companyId && form.dataset.listId);
    steps.forEach(function (step) {
      step.querySelectorAll('button').forEach(function (button) { button.dataset.idleLabel = button.textContent; });
    });

    function message(text, isError) {
      status.hidden = false;
      status.textContent = text;
      status.classList.toggle('fw-signup__status--error', Boolean(isError));
    }

    function updateControls() {
      form.dataset.signupStage = stage;
      steps.forEach(function (step) {
        var active = step.dataset.signupStep === stage;
        step.hidden = !active;
        step.disabled = !active || busy || !configured;
        step.querySelectorAll('button').forEach(function (button) {
          button.disabled = !active || busy || !configured;
          button.textContent = active && busy && button.type === 'submit' ? form.dataset.sending : button.dataset.idleLabel;
        });
      });
      if (busy) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
    }

    function focusStage() {
      if (stage === 'done') status.focus();
      else {
        var current = steps.find(function (step) { return step.dataset.signupStep === stage; });
        var input = current && current.querySelector('input');
        if (input) input.focus();
      }
    }

    function finish(withSms) {
      stage = 'done';
      message(withSms ? form.dataset.acceptedSms : form.dataset.acceptedEmail, false);
      updateControls();
      focusStage();
    }

    function afterName() {
      if (phone) {
        stage = 'sms';
        message(form.dataset.emailReceived, false);
        updateControls();
        focusStage();
      } else finish(false);
    }

    function validate() {
      var address = email.value.trim();
      var local = address.split('@')[0];
      var emailError = '';
      if (stage === 'email') {
        if (/[^\x00-\x7f]/.test(local)) emailError = form.dataset.emailFormatError || form.dataset.emailError;
        else if ((email.maxLength > 0 && address.length > email.maxLength) || /[^\x00-\x7f]/.test(address) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) emailError = form.dataset.emailError;
      }
      email.setCustomValidity(emailError);
      if (phone) {
        var digits = phoneDigits(phone.value);
        phone.required = false;
        phone.setCustomValidity(stage === 'sms' && phone.value.trim() && digits.length !== 10 ? form.dataset.phoneError : '');
      }
    }

    // Capture only known signup context; keep native Klaviyo acquisition fields intact.
    function attributionProperties() {
      var properties = {
        david_signup_source: 'password-page',
        'David Harris Jr. Signup Source': 'David Harris Jr. - Password Page',
        'David Harris Jr. Form Name': form.dataset.signupFormName || 'Password page signup',
        'David Harris Jr. Signup Phase': form.dataset.signupPhase || 'password',
        'David Harris Jr. Latest Signup Submitted At': new Date().toISOString(),
        'David Harris Jr. Form Version': '2026-11-02'
      };
      try {
        var page = new URL(window.location.href);
        // Do not copy arbitrary query strings, fragments, or credentials into profiles.
        properties['David Harris Jr. Signup Page URL'] = page.origin + page.pathname;
        ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) {
          var value = (page.searchParams.get('utm_' + key) || '').trim();
          if (value) {
            properties['David Harris Jr. UTM ' + key.charAt(0).toUpperCase() + key.slice(1)] = value.slice(0, 200);
            properties['David Harris Jr. UTM Captured At'] = properties['David Harris Jr. Latest Signup Submitted At'];
          }
        });
      } catch (error) { /* Missing URL context must not block an email signup. */ }
      try {
        var referrer = new URL(document.referrer);
        if (/^https?:$/.test(referrer.protocol)) properties['David Harris Jr. Referrer Origin'] = referrer.origin;
      } catch (error) { /* Browsers may withhold the referrer. */ }
      if (window.navigator && window.navigator.language) properties['David Harris Jr. Browser Language'] = window.navigator.language;
      try {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) properties['David Harris Jr. Browser Time Zone'] = timezone;
      } catch (error) { /* Time zone reporting is optional. */ }
      return properties;
    }

    function subscriptionPayload(attributes, source, disclosureVersion) {
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'David Harris Jr. - Password Page - ' + (form.dataset.signupFormName || 'Signup') + ' - ' + source + '; disclosure v' + (disclosureVersion || '2026-11-02'),
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: source === 'email signup' ? form.dataset.listId : (form.dataset.smsListId || form.dataset.listId) } } }
        }
      };
    }

    if (phone) phone.addEventListener('input', function () { formatPhoneInput(phone); });
    form.addEventListener('input', function () {
      validate();
      if (!busy && stage !== 'done') {
        if (stage === 'email') status.hidden = true;
        else message(form.dataset.emailReceived, false);
      }
    });
    form.querySelectorAll('[data-signup-skip]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (busy || !configured) return;
        if (stage === 'name') afterName();
        else if (stage === 'sms') finish(false);
      });
    });
    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.isComposing || event.keyCode === 229 || event.ctrlKey || event.altKey || event.metaKey) return;
      if (event.target !== email && event.target !== name && event.target !== phone) return;
      // The first (email) submit button is disabled on later steps, so implicit
      // browser submission needs the currently active submit button explicitly.
      event.preventDefault();
      if (busy || stage === 'done' || !configured) return;
      var current = steps.find(function (step) { return step.dataset.signupStep === stage; });
      var button = current && current.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
      else button.click();
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy || stage === 'done' || !configured) return;
      email.value = normalizeEmail(email.value);
      name.value = name.value.trim();
      validate();
      if (!form.reportValidity()) return;
      if (stage === 'name' && !name.value) { afterName(); return; }
      if (stage === 'sms' && !phone.value.trim()) { finish(false); return; }
      if (stage === 'sms' && (!smsConsent || !smsConsent.checked)) {
        message(form.dataset.consentError, true);
        if (smsConsent) smsConsent.focus();
        return;
      }
      var requestStage = stage;
      var endpoint = 'subscriptions';
      var payload;
      var emailForRequest = requestStage === 'email' ? email.value : submittedEmail;
      if (requestStage === 'email') {
        signupAttribution = attributionProperties();
        payload = subscriptionPayload({
          email: emailForRequest,
          properties: Object.assign({}, signupAttribution, { 'David Harris Jr. Latest Signup Step': 'Email submitted' }),
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        }, 'email signup');
      } else if (requestStage === 'name') {
        endpoint = 'profiles';
        var names = name.value.split(/\s+/);
        var profile = { email: emailForRequest, first_name: names.shift(), properties: Object.assign({}, signupAttribution, { david_signup_name: name.value, 'David Harris Jr. Latest Signup Step': 'Name submitted' }) };
        if (names.length) profile.last_name = names.join(' ');
        payload = { data: { type: 'profile', attributes: profile } };
      } else {
        payload = subscriptionPayload({
          email: emailForRequest,
          phone_number: '+1' + phoneDigits(phone.value),
          properties: Object.assign({}, signupAttribution, { 'David Harris Jr. Latest Signup Step': 'SMS phone submitted' }),
          subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
        }, 'optional SMS signup - phone submitted', '2026-11-02');
      }
      busy = true;
      status.hidden = true;
      updateControls();
      var controller;
      var timeout;
      var timedOut = false;
      try {
        if (typeof window.AbortController === 'function') {
          try { controller = new window.AbortController(); }
          catch (error) { /* Timeout recovery must also work without an abort controller. */ }
        }
        var options = {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(payload)
        };
        if (controller) options.signal = controller.signal;
        var response = await Promise.race([
          fetch('https://a.klaviyo.com/client/' + endpoint + '?company_id=' + encodeURIComponent(form.dataset.companyId), options),
          new Promise(function (resolve, reject) {
            timeout = window.setTimeout(function () {
              timedOut = true;
              reject(new Error('Signup request timed out'));
              if (controller) {
                try { controller.abort(); } catch (error) { /* Controls still recover if abort fails. */ }
              }
            }, 25000);
          })
        ]);
        form.dataset.lastResponseStatus = String(response.status);
        if (response.status !== 202) {
          message(response.status === 429 ? form.dataset.rateError : requestStage === 'name' ? form.dataset.nameSaveError : requestStage === 'sms' ? form.dataset.smsSaveError : form.dataset.error, true);
          return;
        }
        if (requestStage === 'email') {
          submittedEmail = emailForRequest;
          stage = 'name';
          message(form.dataset.emailReceived, false);
        } else if (requestStage === 'name') {
          stage = phone ? 'sms' : 'done';
          message(stage === 'done' ? form.dataset.acceptedEmail : form.dataset.emailReceived, false);
        } else {
          var partialFailure = response.headers && response.headers.get('X-Klaviyo-Partial-Failure');
          if (partialFailure) {
            message(form.dataset.smsPartialError || form.dataset.smsSaveError, true);
            return;
          }
          stage = 'done';
          message(form.dataset.acceptedSms, false);
        }
      } catch (error) {
        var stepError = requestStage === 'name' ? form.dataset.nameSaveError : requestStage === 'sms' ? form.dataset.smsSaveError : form.dataset.error;
        var connectionError = timedOut ? form.dataset.timeoutError : form.dataset.networkError;
        message(connectionError ? connectionError + (requestStage === 'email' ? '' : ' ' + stepError) : stepError, true);
      } finally {
        window.clearTimeout(timeout);
        busy = false;
        updateControls();
        if (stage !== requestStage) focusStage();
      }
    });
    updateControls();
    if (!configured) message(form.dataset.unavailable, true);
    var loadError = form.querySelector('[data-signup-load-error]');
    if (loadError) loadError.hidden = true;
    if (form.fwSignupLoadTimer) window.clearTimeout(form.fwSignupLoadTimer);
    form.dataset.fwSignupBound = 'true';
  }

  function initialize(scope) { scope.querySelectorAll('[data-fw-signup]').forEach(bind); }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
